import "./ContentHeader.css";
import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import ContentItem from "shared/components/cms/ContentItem";

@observer
class ContentHeader extends React.Component {
    static propTypes = {
        name: PropTypes.string.isRequired
    };

    render() {
        const sharedContentKey = this.props.name;
        const sectionTitleContentKey = `${sharedContentKey}PageTitle`;
        const headerStyle = {
            backgroundImage: `url(${require("../../assets/bg_hp_01_hero.jpg")})`
        };
        return (
            <section className="content-header" style={headerStyle}>
                <div className="content-header-body">
                    <div className="content-header-title">
                        <ContentItem tag="h1" sharedKey={sharedContentKey} contentKey={sectionTitleContentKey} />
                    </div>
                </div>
            </section>
        );
    }
}

export default ContentHeader;
